import News from 'features/news';
import { useTitle } from '../helpers';

/**
 * @page Absence page
 */
const NewsPage = () => {
  useTitle('Новости');

  return (
    <div>
      <News />
    </div>
  );
};

export default NewsPage;
